import React, { type PropsWithChildren } from 'react';
import mediaQuery from 'css-mediaquery';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { embraceTheme } from '@care/material-ui-theme';

/**
 * Renders the theme provider with the correct theme based on the feature flags
 */
const ThemeProvider = ({ isMobile, children }: PropsWithChildren<{ isMobile: boolean }>) => {
  const currentTheme = embraceTheme;

  const ssrMatchMedia = (query: string) => {
    return {
      matches: mediaQuery.match(query, {
        // The estimated CSS width of the browser.
        width: isMobile ? '1px' : '1400px',
      }),
    };
  };

  currentTheme.components = {
    ...currentTheme.components,
    // Change the default options of useMediaQuery
    MuiUseMediaQuery: {
      defaultProps: {
        ssrMatchMedia,
      },
    },
  };

  return <MuiThemeProvider theme={currentTheme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
